import { Button } from '@mui/material';
import MuiModal from '@mui/material/Modal';
import './Modal.scss';

 const Modal = ({ data, open, handleClose }) => {
  return (
    <div className="modal-container">
      <MuiModal
        open={open}
        onClose={handleClose}
        aria-label="Delete Popup"
      >
        <div className={'modal-box'}>
            <i className='icon-close icon-close-modal' onClick={handleClose}  />
            <h1 className="icon"><span className="icon-circle-flight"></span></h1>
            <h2 className="title">{data.title}</h2>
            <p className="question">
                {data.question}
            </p>
            <p className="description">
                {data.description}
            </p>
            <div className="buttons">
                <Button className='btn-white' onClick={data.handleCancel} ><span>{data.cancelLabel}</span></Button>
                <Button className='btn-black' onClick={data.handleDelete}><span>{data.deleteLabel}</span></Button>
            </div>
        </div>
      </MuiModal>
    </div>
  );
};

export default Modal;